<template>
  <text-setting-update
    :fontFamily.sync="configData.fontFamily"
    :fontSize.sync="configData.fontSize"
    :fontWeight.sync="configData.fontWeight"
    :fontColor.sync="configData.fontColor"
    :colorMode.sync="configData.colorMode"
    :colorArr.sync="configData.colorArr"
    :isThemeColor.sync="configData.textIsThemeColor"
    :options="configData"
    :inMapSet="true"
    @updateAttrs="updateAttrs"
  />
</template>
<script>
import complexSetMixin from "./complexSetMixin.js"
import textSettingUpdate from "@/modules/components/textSetting_update.vue"
import { produce } from "immer";
export default {
  mixins: [complexSetMixin()],
  components: {
    textSettingUpdate
  },
  methods: {
    updateAttrs(attrs) {
      this.configData = produce(this.configData, draft => {
        Object.entries(attrs).forEach(([key, value]) => {
          draft[key] = value
        })
      })
    }
  }
}
</script>